import {
    SetupData, APIVersion, BearerFunction, ServiceTypes,
} from './types/main';

let setupData: SetupData = {
    member_token: undefined,
    notification_hub_token: undefined,
    application_token: undefined,
    application_generic_token: undefined,

    withBearerApplicationAccessToken: false,
    bearerAccessToken: undefined,
    bearerApplicationAccessToken: undefined,
    bearerFIdentityAccessToken: undefined,
    headers: {},
    isVersionIncluded: false,
    GATEWAY_API_URL: '',
    SERVICES_URL_SUFFIX: '',
    GRAPHQL_URL_SUFFIX: '',
    DMS_URL_SUFFIX: '',
    CUSTOM_URL_SUFFIX: '',
    DMS_URL: undefined,
    GRAPHQL_URL: undefined,
    SERVICES_URL: undefined,
    CUSTOM_URL: undefined,
    ENGAGEMENT_CONTENT_URL: undefined,
    ENGAGEMENT_CONTENT_URL_SUFFIX: '',
    FIDENTITY_URL: undefined,
    FIDENTITY_URL_SUFFIX: '',
    CLIENT_SERVICE_URL_SUFFIX: '',
    CREDITSERVICELAYER_SERVICE_URL_SUFFIX: '',
    CSL_URL_SUFFIX: '',
    WMS_SERVICE_URL_SUFFIX: '',
    CLIENT_SERVICE_HEADERS: {},
    CUSTOM_SERVICE_LAYER_HEADERS: {},
    CLIENT_SERVICE_MEMBER_URL_SUFFIX: '',
    IFRAME_CASE_MANAGEMENT_URL: '',
    BO_ADDITIV_URL: '',
    BO_ZIAG_URL: '',
    CREDIT_APP_URL: '',
    CREDIT_APP_ZIAG_URL: '',
    SYSTEM_MESSAGE_FEATURE_FLAG: false,
    CREDIT_INTEGRATION_FEATURE_FLAG: false,
    UPLOAD_STATIC_DOCUMENT_FEATURE_FLAG: false,
    PRODUCT_PROPOSAL_FEATURE_FLAG: false,
};

const ServiceTypeToActionMap: Record<string, BearerFunction> = {
    [ServiceTypes.FIDENTITY]: () => getBearerFIdentityAccessToken(),
    [ServiceTypes.DFS]: (isSecure: boolean) => (isSecure ? getBearerAccessToken() : (getBearerApplicationAccessToken() || getBearerAccessToken())),
    [ServiceTypes.DMS]: (isSecure: boolean) => (isSecure ? getBearerAccessToken() : (getBearerApplicationAccessToken() || getBearerAccessToken())),

    [ServiceTypes.WITH_APP_TOKEN]: (isSecure: boolean) => getApplicationToken(),
    [ServiceTypes.WITH_MEMBER_TOKEN]: (isSecure: boolean) => getMemberToken(),
    [ServiceTypes.WITH_GENERIC_TOKEN]: (isSecure: boolean) => getGenericToken(),
};

const showLogs: boolean = false;

const getAuthorizationHeader = (type: ServiceTypes, isSecure: boolean): Record<string, string> => {
    const Authorization = getBearerAccessTokenByType(type, isSecure);

    if (showLogs) { console.log(`getAuthorizationHeader(type: ${type}, isSecure: ${isSecure})`); }

    return Authorization === undefined ? {} : { Authorization };
};

export const setup = (data: Partial<SetupData>): void => {
    setupData = {
        ...setupData,
        ...data,
    };
};

const getAdditionalHeaders = (): Record<string, string> => (
    setupData.headers
);

export const getBearerAccessToken = (): string | undefined => (
    setupData.bearerAccessToken
);

export const getBearerAccessTokenByType = (type: ServiceTypes, isSecure: boolean): string | undefined => ServiceTypeToActionMap[type](isSecure);

export const getBearerApplicationAccessToken = (): string | undefined => (
    setupData.bearerApplicationAccessToken
);

export const getMemberToken = (): string | undefined => (
    `Bearer ${setupData.member_token}`
);

export const getApplicationToken = (): string | undefined => (
    setupData.application_token
);

export const getGenericToken = (): string | undefined => (
    setupData.application_generic_token
);

export const getBearerFIdentityAccessToken = (): string | undefined => (
    setupData.bearerFIdentityAccessToken
);

export const getServicesUrl = (version: APIVersion = APIVersion.V10): string => {
    if (setupData.SERVICES_URL !== undefined) {
        return setupData.isVersionIncluded
            ? `${setupData.SERVICES_URL}`
            : `${setupData.SERVICES_URL}/${version}`;
    }

    return `${setupData.GATEWAY_API_URL}${setupData.SERVICES_URL_SUFFIX}/${version}`;
};

export const getGatewayApiUrl = (): string => {
    if (setupData && setupData.GATEWAY_API_URL !== undefined) {
        return `${setupData.GATEWAY_API_URL}`;
    }

    return '';
};

export const getGraphQLApiUrl = (): string => {
    if (setupData.GRAPHQL_URL !== undefined) {
        return `${setupData.GRAPHQL_URL}`;
    }

    return `${setupData.GATEWAY_API_URL}${setupData.GRAPHQL_URL_SUFFIX}`;
};

export const getHeaders = (type: ServiceTypes, isSecure: boolean): Record<string, string> => ({
    'Content-Type': 'application/json',
    ...getAdditionalHeaders(),
    ...getAuthorizationHeader(type, isSecure),
});

export const withBearerApplicationAccessToken = (): boolean => (
    setupData.withBearerApplicationAccessToken
);

export const getDmsUrl = (version: APIVersion = APIVersion.V10): string => {
    if (setupData.DMS_URL !== undefined) {
        return setupData.isVersionIncluded
            ? `${setupData.DMS_URL}`
            : `${setupData.DMS_URL}/${version}`;
    }

    return `${setupData.GATEWAY_API_URL}${setupData.DMS_URL_SUFFIX}/${version}`;
};

export const getCustomUrl = (): string => {
    if (setupData.CUSTOM_URL !== undefined) {
        return `${setupData.CUSTOM_URL}`;
    }

    return `${setupData.GATEWAY_API_URL}${setupData.CUSTOM_URL_SUFFIX}`;
};

export const getEngagementContentUrl = (version: APIVersion = APIVersion.V10): string => {
    if (setupData.ENGAGEMENT_CONTENT_URL !== undefined) {
        return `${setupData.ENGAGEMENT_CONTENT_URL}/${version}`;
    }

    return `${setupData.GATEWAY_API_URL}${setupData.ENGAGEMENT_CONTENT_URL_SUFFIX}/${version}`;
};

export const getFIdentityUrl = (version: APIVersion = APIVersion.V1): string => {
    if (setupData.FIDENTITY_URL !== undefined) {
        return `${setupData.FIDENTITY_URL}/${version}`;
    }

    return `${setupData.GATEWAY_API_URL}${setupData.FIDENTITY_URL_SUFFIX}/${version}`;
};

export const getClientServiceUrl = (version: APIVersion = APIVersion.V10): string => `${setupData.GATEWAY_API_URL}${setupData.CLIENT_SERVICE_URL_SUFFIX}/${version}`;
export const getCreditServiceUrl = (service: string, version: APIVersion = APIVersion.V10): string => `${setupData.GATEWAY_API_URL}${setupData.CREDITSERVICELAYER_SERVICE_URL_SUFFIX}/${version}/${service}`;

export const getWmsServiceUrl = (version: APIVersion = APIVersion.V10): string => `${setupData.GATEWAY_API_URL}${setupData.WMS_SERVICE_URL_SUFFIX}/${version}`;

export const getClientServiceHeader = (): Record<string, string> => setupData.CLIENT_SERVICE_HEADERS;
export const getCustomServiceLayerHeader = (): Record<string, string> => setupData.CUSTOM_SERVICE_LAYER_HEADERS;

export const getSetupData = (): SetupData => setupData;
